const ExchangeData = [
	{
		walletAccountId: 2,
		image: '/images/partners/zero13Logo.png',
		name: 'Zero13',
		address: '0xfc7eef6fc63ae5665e7b5b540db17e73f189cf2b'
	}
];

export default ExchangeData;
